// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileButton_root__2baBT","primary":"ProfileButton_primary__2GWZf","secondary":"ProfileButton_secondary__15KhI","gray":"ProfileButton_gray__1S20M"};